module.exports = __webpack_public_path__ + "img/android-icon.cfbfacb4.svg";